export enum UIAddCapsuleMode {
  DEFAULT = 'DEFAULT',
  CLICKED = 'CLICKED',
  ADDING = 'ADDING'
}
